import {
  Row,
  Col,
  Card,
  message,
  Form,
  Input,
  Switch,
  Button,
  Typography,
  Upload,
  Select,
  Space,
  Modal,
} from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";

import LiveStreaming from "../audio_recorder/views/Room";


const { Title } = Typography;

const StreamingManagement = ({
  prefixTitle = ""
}) => {

  useEffect(() => {
    document.title = `${prefixTitle} | 線上直播`

    // getWebsiteBasicInformationData();
    // getCommunityData();
  }, []);

  return (
    <Row
      gutter={[10, 20]}
      justify="space-around"
      style={{ padding: "20px", backgroundColor: "#f5f5f5" }}
    >

      <Col span={24}>
        <Card title="線上直播">
          <LiveStreaming routePrefix={'/officialweb/admin/audio_recorder/liveAdmin/'} />
        </Card>
      </Col>
    </Row>
  );
};
export default StreamingManagement;
